import {
  IBuildingSchema,
  ILandSchema,
  INewObjectSchema,
  IOfferSchema,
  TCategory,
} from '@cian/api-models/offer-card/v1/get-offer-data';
import { FDealType, getDealType } from './deal_type';
import { getLandAreaUnitType } from './offer_helpers';

export function getFloorInfo(floorNumber: number | null, buildingInfo: IBuildingSchema | null): string {
  if (floorNumber && buildingInfo && buildingInfo.floorsCount !== null) {
    return `этаж ${floorNumber}/${buildingInfo.floorsCount}`;
  }

  if (floorNumber) {
    return `этаж ${floorNumber}`;
  }

  return '';
}

export function getTotalArea(area: string | null, land: ILandSchema | null): string {
  if (!area) {
    return '';
  }

  if (land) {
    return `${Number(land.area)} ${getLandAreaUnitType(land)}`;
  }
  if (area) {
    return `${Number(area)} м.кв.`;
  }

  return '';
}

export function getJkName(category: TCategory, newObject: INewObjectSchema | null): string {
  if (newObject && category) {
    return category === 'newBuildingFlatSale' ? `в ${newObject.name}` : '';
  }

  return '';
}

export function getDealTypeText(offer: IOfferSchema): string {
  const dealType = getDealType(offer);
  const rentPrefix = offer.isApartments ? 'Сдаются' : 'Сдаётся';

  if (dealType === FDealType.Sale) {
    return offer.isApartments ? 'Продаются' : 'Продаётся';
  }

  if (dealType === FDealType.RentDaily) {
    return `${rentPrefix} посуточно`;
  }

  return rentPrefix;
}
